import { render, staticRenderFns } from "./detailImportBatchTables.vue?vue&type=template&id=dc8de226&"
import script from "./detailImportBatchTables.vue?vue&type=script&lang=js&"
export * from "./detailImportBatchTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports